import Vue from 'vue'
import { Button, Form, FormItem, Input, Message, Container, Header, Aside, Main, Menu, Submenu, MenuItem, Breadcrumb, BreadcrumbItem,Progress, Card, Row, Col, Table, TableColumn, Pagination, Dialog, Option, Select, Tooltip, MessageBox, TimeSelect,DatePicker ,Checkbox ,CheckboxGroup,DropdownMenu,DropdownItem,Dropdown,Upload} from 'element-ui'

Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Header)
Vue.use(Container)
Vue.use(Main)
Vue.use(Aside)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Option)
Vue.use(Select)
Vue.use(Tooltip)
Vue.use(TimeSelect)
Vue.use(DatePicker)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Dropdown)
Vue.use(Upload)
Vue.use(Progress)
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
